<template>
    <span
        v-if="seat"
        :class="{ blocked: !seat.available, taken: seat.taken }"
    >
        <input
            type="checkbox"
            :id="seat.hashid"
            v-model="seat.selected"
            :disabled="!seat.available || (seat.taken && !originalSelections.includes(seat.hashid))"
            @change="selectedStatusChanged()"
        >
        <label
            :for="seat.hashid"
            :data-cy="`${seat.section}_${seat.section_seq}`"
        >
            <img
                :src="seat.image + '?dt=20220922'"
                :class="{couch: seat.isCouch, wheelchair: seat.is_wheelchair_space}"
            >
        </label>
    </span>
<!--    </div>-->
</template>

<script>
export default {
    props: {
        seat: {
            type: Object,
        },
        originalSelections: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
        }
    },
    methods: {
        selectedStatusChanged() {
            this.$emit('change', this.seat.selected);
        },
    }
}
</script>

<style lang="scss">

</style>
